__turbopack_context__.v({
  "app-store-links": "zoocasaFooterStyle-module-scss-module__6GvmBG__app-store-links",
  "block": "zoocasaFooterStyle-module-scss-module__6GvmBG__block",
  "block1": "zoocasaFooterStyle-module-scss-module__6GvmBG__block1",
  "block2": "zoocasaFooterStyle-module-scss-module__6GvmBG__block2",
  "block3": "zoocasaFooterStyle-module-scss-module__6GvmBG__block3",
  "block4": "zoocasaFooterStyle-module-scss-module__6GvmBG__block4",
  "brokerage-legal-name": "zoocasaFooterStyle-module-scss-module__6GvmBG__brokerage-legal-name",
  "component": "zoocasaFooterStyle-module-scss-module__6GvmBG__component",
  "contact": "zoocasaFooterStyle-module-scss-module__6GvmBG__contact",
  "contact-item": "zoocasaFooterStyle-module-scss-module__6GvmBG__contact-item",
  "exp-copyright": "zoocasaFooterStyle-module-scss-module__6GvmBG__exp-copyright",
  "exp-logo": "zoocasaFooterStyle-module-scss-module__6GvmBG__exp-logo",
  "exp-logo-container": "zoocasaFooterStyle-module-scss-module__6GvmBG__exp-logo-container",
  "feature-flags": "zoocasaFooterStyle-module-scss-module__6GvmBG__feature-flags",
  "features": "zoocasaFooterStyle-module-scss-module__6GvmBG__features",
  "feedback-button": "zoocasaFooterStyle-module-scss-module__6GvmBG__feedback-button",
  "footer": "zoocasaFooterStyle-module-scss-module__6GvmBG__footer",
  "footer-big-text": "zoocasaFooterStyle-module-scss-module__6GvmBG__footer-big-text",
  "footer-bottom": "zoocasaFooterStyle-module-scss-module__6GvmBG__footer-bottom",
  "footer-links": "zoocasaFooterStyle-module-scss-module__6GvmBG__footer-links",
  "footer-top": "zoocasaFooterStyle-module-scss-module__6GvmBG__footer-top",
  "footer-top-left": "zoocasaFooterStyle-module-scss-module__6GvmBG__footer-top-left",
  "footer-top-right": "zoocasaFooterStyle-module-scss-module__6GvmBG__footer-top-right",
  "heading": "zoocasaFooterStyle-module-scss-module__6GvmBG__heading",
  "hide-desktop": "zoocasaFooterStyle-module-scss-module__6GvmBG__hide-desktop",
  "hide-mobile": "zoocasaFooterStyle-module-scss-module__6GvmBG__hide-mobile",
  "invert": "zoocasaFooterStyle-module-scss-module__6GvmBG__invert",
  "join-button": "zoocasaFooterStyle-module-scss-module__6GvmBG__join-button",
  "join-image-container": "zoocasaFooterStyle-module-scss-module__6GvmBG__join-image-container",
  "join-link": "zoocasaFooterStyle-module-scss-module__6GvmBG__join-link",
  "join-section": "zoocasaFooterStyle-module-scss-module__6GvmBG__join-section",
  "join-section-mobile-container": "zoocasaFooterStyle-module-scss-module__6GvmBG__join-section-mobile-container",
  "listing-links": "zoocasaFooterStyle-module-scss-module__6GvmBG__listing-links",
  "office-address": "zoocasaFooterStyle-module-scss-module__6GvmBG__office-address",
  "owned-by-row": "zoocasaFooterStyle-module-scss-module__6GvmBG__owned-by-row",
  "social-ig-icon": "zoocasaFooterStyle-module-scss-module__6GvmBG__social-ig-icon",
  "social-x-icon": "zoocasaFooterStyle-module-scss-module__6GvmBG__social-x-icon",
  "socials": "zoocasaFooterStyle-module-scss-module__6GvmBG__socials",
  "terms-and-conditions": "zoocasaFooterStyle-module-scss-module__6GvmBG__terms-and-conditions",
  "zoocasa-by-exp-logo": "zoocasaFooterStyle-module-scss-module__6GvmBG__zoocasa-by-exp-logo",
  "zoocasa-logo": "zoocasaFooterStyle-module-scss-module__6GvmBG__zoocasa-logo",
});
